// extracted by mini-css-extract-plugin
module.exports = {"stepper":"Confirmation-module__stepper___1YF4u","instructions":"Confirmation-module__instructions___3b-bi","buttons":"Confirmation-module__buttons___2MRWN"};